
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productsToshow = parseInt(this.dataset.productsToShow, 10);
      this.init();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector(
            'recently-viewed-products'
          );

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.products = recommendations.querySelectorAll(
              '.card-wrapper'
            ).length;

            if (this.products > 0) {
              this.classList.remove('hidden');

              // Insert recently viewed product cards
              this.innerHTML = recommendations.innerHTML;
              
// setTimeout(() => {
//   this.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
//     // Never replace an existing Judge.me rating
//     if (badge.querySelector('.jdgm-prev-badge__stars')) return;

//     // Only display a fallback for badges with no content
//     if (badge.innerHTML.trim() !== '') return;

//     badge.innerHTML = `
//       <div class="myoc-zero-review-rating">
//         <span class="myoc-zero-stars" aria-hidden="true">☆☆☆☆☆</span>
//         <span>No reviews</span>
//       </div>
//     `;
//   });
// }, 1500);


              // Initialize Judge.me ratings after insertion
              this.initializeJudgeMe();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initializeJudgeMe() {
      const refreshRatings = () => {
        if (
          window.jdgm &&
          typeof window.jdgm.refreshAllWidgets === 'function'
        ) {
          window.jdgm.refreshAllWidgets();
          return true;
        }

        return false;
      };

      if (refreshRatings()) return;

      // Judge.me may load after the product cards
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;

        if (refreshRatings() || attempts >= 10) {
          clearInterval(interval);
        }
      }, 500);
    }

    getQueryString() {
      const cookieName = 'utenzo-recently-viewed';
      const items = JSON.parse(
        window.localStorage.getItem(cookieName) || '[]'
      );

      if (
        this.dataset.productId &&
        items.includes(parseInt(this.dataset.productId, 10))
      ) {
        items.splice(
          items.indexOf(parseInt(this.dataset.productId, 10)),
          1
        );
      }

      return items
        .reverse()
        .map((item) => 'id:' + item)
        .slice(0, this.productsToshow)
        .join(' OR ');
    }
  }

  customElements.define(
    'recently-viewed-products',
    RecentlyViewedProducts
  );
}
